var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"ma-1 ml-0",attrs:{"small":"","color":_vm.categoryColor,"text-color":_vm.textColor}},[_vm._v(" "+_vm._s(_vm.category)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }